export function tempoRelativo(iso){
  if(!iso) return 'ainda não atualizado';
  const seg = (Date.now() - new Date(iso).getTime()) / 1000;
  if(seg < 60) return 'agora mesmo';
  if(seg < 3600) return `há ${Math.floor(seg/60)} min`;
  if(seg < 86400) return `há ${Math.floor(seg/3600)} h`;
  const d = new Date(iso);
  return `em ${d.toLocaleDateString('pt-BR')}`;
}
export function dataHora(iso){
  if(!iso) return '—';
  const d = new Date(iso);
  return `${d.toLocaleDateString('pt-BR')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
}
